import { render, staticRenderFns } from "./TransferenciasConsulta.vue?vue&type=template&id=264744b3&"
import script from "./TransferenciasConsulta.vue?vue&type=script&lang=js&"
export * from "./TransferenciasConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports